<div class="loading-container order-history-block">
  @if (orders()?.length > 0) { @if (orders()?.length > 0) {
  <!-- <ng-container *ngIf="isCustomView()"> -->
  <div class="row">
    <!-- <div class="col-md-8 mb-3">
        <label>Sort By</label>
        <select class="select-option" #sortSelect (change)="sortBy(sortSelect.value)">
          <option
            class="option"
            *ngFor="let option of sortOptionsMap | keyvalue"
            [value]="option.value"
            [selected]="option.value === selected"
            >
            {{ option.key }}
          </option>
        </select>
      </div> -->
    <!-- <div class="col-md-4">
      <ng-container *ishIsAuthorizedTo="'APP_B2B_MANAGE_USERS'">
        {{ changePlaceHolder() }}
      </ng-container>
      <ng-container *ngIf="searchPlaceHolder$ | async as searchPlaceHolder" />
    </div> -->
  </div>
  <!-- </ng-container> -->
  }
  <table
    cdk-table
    [dataSource]="orders()"
    class="table table-lg mobile-optimized"
    data-testing-id="requisition-list"
    infiniteScroll
    [alwaysCallback]="true"
    [immediateCheck]="true"
  >
    <!-- Order creation date -->
    <ng-container cdkColumnDef="creationDate">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-creation-date">
        {{ 'account.orderlist.table.date_of_order' | translate }}
      </th>
      <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.date_of_order' | translate">
        {{ order.creationDate | ishDate }}
      </td>
    </ng-container>
    <!-- Order number -->
    <ng-container cdkColumnDef="orderNo">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-number">
        <span aria-hidden="true">{{ 'account.orderlist.table.order_number' | translate }}</span>
        <span class="sr-only">{{ 'account.orderlist.table.order_number.title' | translate }}</span>
      </th>
      <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.order_number.title' | translate">
        {{ order.documentNo }}
      </td>
    </ng-container>
    <ng-container cdkColumnDef="orderNoWithLink">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-number">
        {{ 'account.orderlist.table.order_number' | translate }}
      </th>
      <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.order_number.title' | translate">
        <a [routerLink]="'/account/orders/' + order.id">{{ order.documentNo }}</a>
      </td>
    </ng-container>
    <!-- Buyer -->
    <ng-container cdkColumnDef="buyer">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef data-testing-id="th-buyer">
        @if (view() === 'cost-center') {
        {{ 'account.orderlist.table.buyer' | translate }}
        } @else {
        <ng-container *ishIsAuthorizedTo="['APP_B2B_MANAGE_USERS', 'APP_B2B_ORDER_APPROVAL']">{{
          'account.orderlist.table.buyer' | translate
        }}</ng-container>
        }
      </th>
      <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.buyer' | translate">
        <!-- <ng-container *ngIf="view === 'cost-center'; else buyersForOrderHistory"> -->
        <!-- {{ getBuyerName(order.attributes) }} -->
        <!-- {{ order?.user?.firstName }} {{ order?.user?.lastName }} -->
        <!-- </ng-container> -->
        <!-- <ng-template #buyersForOrderHistory>
    <ng-container *ishIsAuthorizedTo="'APP_B2B_MANAGE_USERS'"> -->
        <!-- {{ getBuyerNameUsingOrder(order) }} -->
        <!-- </ng-container>
  </ng-template> -->
        {{ order.user?.firstName }} {{ order.user?.lastName }}
      </td>
    </ng-container>
    <!-- Number of Items  -->
    <ng-container cdkColumnDef="lineItems">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-items">
        {{ 'account.orderlist.table.items' | translate }}
      </th>
      <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.items' | translate">
        {{ order.lineItems?.length ? order.lineItems?.length : order?.totalProductQuantity }}
      </td>
    </ng-container>
    <!-- Status  -->
    <ng-container cdkColumnDef="status">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-status">
        {{ 'account.orderlist.table.order_status' | translate }}
      </th>
      <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.order_status' | translate">
        <span class="badge badge-info">{{ order.status }}</span>
      </td>
    </ng-container>
    <!-- Destination  -->
    <ng-container cdkColumnDef="destination">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef data-testing-id="th-order-destination">
        {{ 'account.orderlist.table.destination' | translate }}
      </th>
      <td cdk-cell *cdkCellDef="let order" [attr.data-label]="'account.orderlist.table.destination' | translate">
        @if (order.buckets.length > 1) {
        <div>
          <p>{{ 'dias.account.orderlist.table.multiple.destination' | translate }}</p>
        </div>
        } @for (shippingBucket of order.buckets; track shippingBucket) {
        <div>
          <ish-address [address]="shippingBucket.commonShipToAddress || shippingBucket.shipToAddress" />
        </div>
        }
      </td>
    </ng-container>
    <!-- Order total  -->
    <ng-container cdkColumnDef="orderTotal">
      <th scope="col" cdk-header-cell *cdkHeaderCellDef class="text-right" data-testing-id="th-order-total">
        {{ 'account.orderlist.table.order_total' | translate }}
      </th>
      <td
        cdk-cell
        *cdkCellDef="let order"
        [attr.data-label]="'account.orderlist.table.order_total' | translate"
        class="column-price"
      >
        {{ order.totals.total | ishPrice : 'gross' }}
      </td>
    </ng-container>
    <!-- Header and Row Declarations -->
    <tr cdk-header-row *cdkHeaderRowDef="columnsToDisplay()"></tr>
    <tr cdk-row *cdkRowDef="let row; columns: columnsToDisplay()"></tr>
  </table>
  } @else {
  <!-- <ng-container *ngIf="searchTerm; else emptyListWithoutSearch"> -->
  <!-- <ng-container *ngIf="searchTerm; then SearchSortTool" /> -->
  <p data-testing-id="emptyList">{{ 'dias.order.search.noOrdersMessageKey' | translate }}</p>
  <!-- </ng-container> -->
  }

  <!-- <ng-template #emptyListWithoutSearch>
<p data-testing-id="emptyList">{{ noOrdersMessageKey | translate }}</p>
</ng-template> -->
  @if (loading()) {
  <ish-loading />
  }
</div>
